import { LISTENING_SESSION_POLICY } from '@repo/config';
import { z } from 'zod';

const listeningSessionResultSchema = z.object({
  challengeId: z.number().int().positive(),
  clipId: z.number().int().positive(),
  caught: z.boolean(),
});

const saveListeningSessionV1RequestSchemaDefinition = z.object({
  sessionId: z.string().uuid(),
  results: z.array(listeningSessionResultSchema).min(1).max(LISTENING_SESSION_POLICY.size),
});

export const saveListeningSessionV1RequestSchema: typeof saveListeningSessionV1RequestSchemaDefinition =
  saveListeningSessionV1RequestSchemaDefinition;

export type ISaveListeningSessionV1Request = z.infer<typeof saveListeningSessionV1RequestSchema>;

export type IListeningSessionResult = ISaveListeningSessionV1Request['results'][number];
